const getShowtime = (string = null) => {
    const dateObj = string ? new Date(string) : new Date()

    const hours = dateObj.getHours()
    const minutes = dateObj.getMinutes() 

    const hoursWihZero = hours > 9 ? hours : '0' + hours
    const minutesWihZero = minutes > 9 ? minutes : '0' + minutes

    return hoursWihZero + ':' + minutesWihZero
}

export default getShowtime